module.exports = __webpack_public_path__ + "img/y_p3_y4.ceafcef5.png";